<template>
    <div class="content">
        <div class="flist">
            <div class="d_box">
                <div class="title">基本信息</div>
                <van-cell-group>
                    <van-field readonly v-model="form.shopName" label="门店名称" placeholder="门店名称" :label-width="60"></van-field>
                    <van-field readonly v-model="form.pointCode" label="点位编码" placeholder="点位编码" :label-width="60"></van-field>
                    <van-field readonly v-model="form.pointName" label="点位名称" placeholder="点位名称" :label-width="60"></van-field>
                    <van-field readonly v-model="form.buildName" label="点位位置" placeholder="点位位置" :label-width="60"></van-field>
                    <van-field readonly v-model="form.memo" label="点位描述" placeholder="点位描述" :label-width="60"></van-field>
                    <div v-if="form.itemList && form.itemList!=null && form.itemList.length>0">
                        <div v-for="(item,index) in form.itemList" :key="index">
                            <van-divider dashed :margin="0" :style="{ borderColor: 'rgba(0, 0, 0, 0.2',margin: 0}" v-if="index<form.itemList.length-1 || form.itemList.length==1"></van-divider>
                            <van-field readonly :label="'细化确认项'+(index+1)+'：'"  placeholder="" :label-width="200"></van-field>
                            <van-field readonly :class="{red:item.itemValue==0}" input-align="right" v-model="item.itemValueName" :label="item.itemName"  placeholder="" :label-width="200"></van-field>
                            <van-field readonly label="照片" placeholder="照片">
                                <template #input>
                                    <van-uploader disabled :deletable="false" v-model="item.imgUrltwo" multiple :max-count="1" />
                                </template>
                            </van-field>
                            <van-field readonly type="textarea" rows="1" autosize v-model="item.memo" label="备注" placeholder="备注" :label-width="60"></van-field>
                        </div>
                    </div>
                </van-cell-group>
            </div>

            <div class="d_box">
                <div class="title">任务信息</div>
                <van-cell-group>
                    <van-field readonly v-model="form.missionName" label="所属任务" placeholder="所属任务" :label-width="60"></van-field>
                    <van-field readonly v-model="form.missionTypeName" label="任务类型" placeholder="任务类型" :label-width="60"></van-field>
                    <van-field readonly type="textarea" rows="1" autosize v-model="form.missionMemo" label="任务描述" placeholder="任务描述" :label-width="60"></van-field>
                    <van-field readonly v-model="form.checkUserName" label="任务审核人" placeholder="任务审核人" :label-width="70"></van-field>
                </van-cell-group>
            </div>

            <div class="d_box">
                <div class="title">{{typename}}信息</div>
                <van-cell-group>
                    <van-field readonly v-model="form.expect" :label="'预计'+(periodicType==3?'检查':typename)+'时间段'" :placeholder="'预计'+(periodicType==3?'检查':typename)+'时间段'" :label-width="100"></van-field>
                    <van-field readonly v-model="form.patrolTime" :label="'实际'+(periodicType==3?'检查':typename)+'时间点'" :placeholder="'实际'+(periodicType==3?'检查':typename)+'时间点'" :label-width="100"></van-field>
                    <van-field readonly type="textarea" rows="1" autosize v-model="form.systemOutsidersName" :label="'预计'+(periodicType==3?'检查':typename)+'人'" :placeholder="'预计'+(periodicType==3?'检查':typename)+'人'" :label-width="70"></van-field>
                    <van-field readonly v-model="form.patrolUserName" :label="'实际'+(periodicType==3?'检查':typename)+'人'" :placeholder="'实际'+(periodicType==3?'检查':typename)+'人'" :label-width="70"></van-field>
                    <van-field v-if="form.missionType==2" readonly type="textarea" rows="1" autosize v-model="form.constructionMemo" label="施工内容" placeholder="施工内容" :label-width="60"></van-field>
                    <van-field v-if="form.missionType==2" readonly type="textarea" rows="1" autosize v-model="form.dangerousMemo" label="隐患内容" placeholder="隐患内容" :label-width="60"></van-field>
                    <van-field v-if="form.missionType==1 || form.missionType==3" readonly type="textarea" rows="1" autosize v-model="form.patrolMemo" label="巡查情况" placeholder="巡查情况" :label-width="60"></van-field>
                    <van-field readonly v-model="form.patrolStatus" :label="'点位'+typename+'状态'" :placeholder="'点位'+typename+'状态'">
                        <template #input>
                            <span :class="form.patrolStatus>=0?('scolor'+form.patrolStatus):'scolor5'">{{getstateName(form.patrolStatus) || ''}}</span>
                        </template>
                    </van-field>
                    <van-field readonly label="现场照片" placeholder="现场照片">
                        <template #input>
                            <van-uploader disabled :deletable="false" v-model="picUrlList" multiple :max-count="5" />
                        </template>
                    </van-field>
                </van-cell-group>
            </div>
        </div>
        <div style="height:100px"></div>
        <div v-if="isuser==2 && isshow1">
            <div class="footbtn" v-if="form.patrolStatus>=0 && form.patrolStatus<=3 && isshow">
                <van-button round block type="primary" color="linear-gradient(55deg, #6261DB 0%, #3332B5 100%)" size="middle" @click="getshow()">{{typename}}打卡</van-button>
            </div>
        </div>
        <div class="footbtn" v-else>
            <van-button round block type="primary" color="linear-gradient(55deg, #6261DB 0%, #3332B5 100%)" size="middle" @click="goindex()">前往扫码</van-button>
        </div>
        <van-popup
        v-model="show"
        closeable
        position="bottom"
        round>
            <div class="pop_box">
                <div class="title">{{typename}}打卡</div>
                <van-form class="max60" :show-error-message="false" :scroll-to-error="true" @submit="goSubmit">
                    <van-cell-group inset>
                        <van-field v-model="formtwo.name" readonly name="name" :label="(periodicType==3?'检查':typename)+'人'" :placeholder="typename+'人'" :label-width="60" :rules="[{ required: true, message: typename+'人不能为空' }]"></van-field>
                        <van-field v-model="formtwo.newtime" readonly name="newtime" :label="(periodicType==3?'检查':typename)+'时间'" :placeholder="typename+'时间'" :label-width="60"></van-field>
                        <van-field :required="true" label="是否有异常" :label-width="70">
                            <template #input>
                                <div class="row-end">
                                    <van-switch v-model="formtwo.pointStatus" inactive-color="#ddd"/>
                                </div>
                                <!-- <van-switch v-model="formtwo.pointStatus" inactive-color="#ddd" /> -->
                            </template>
                        </van-field>
                        <div v-for="(item,index) in formtwo.itemList" :key="index">
                            <van-field :label="'细化确认项'+(index+1)+'：'" :label-width="180"></van-field>
                            <van-field :label="item.itemName" :name="'itemList.' + index + '.itemValue'">
                                <template #input>
                                    <div class="row-end">
                                    <van-radio-group v-model="item.itemValue" class="row-end">
                                            <van-radio name="1">正常</van-radio>
                                            <van-radio name="0">异常</van-radio>
                                        </van-radio-group>
                                    </div>
                                    <!-- <van-switch v-model="formtwo.pointStatus" inactive-color="#ddd" /> -->
                                </template>
                            </van-field>
                            <van-field label="照片" :required="item.requiredPhoto==1?true:false" :label-width="60" :name="'itemList.' + index + '.imgUrl'" :rules="[{ required: item.requiredPhoto==1?true:false, message: '请上传照片' }]">
                                <template #input>
                                    <van-uploader v-model="item.imgUrltwo" multiple :max-count="1" :after-read="(file)=>afterRead(file, index)" :before-read="beforeRead" @delete="(file, detail) => deleteImg(file, detail,index)"/>
                                </template>
                            </van-field>
                            <van-field type="textarea" rows="2" autosize v-model="item.memo" :name="'itemList.' + index + '.memo'" label="备注" placeholder="备注" :label-width="60" maxlength="200" readonly></van-field>
                        </div>
                        <van-field v-if="form.missionType==1 || form.missionType==3" required type="textarea" rows="2" autosize v-model="formtwo.patrolMemo" name="patrolMemo" label="巡查情况" placeholder="巡查情况" :label-width="60" maxlength="200" :rules="[{ required: true, message: '巡查情况不能为空' }]"></van-field>
                        <van-field v-if="form.missionType==2" type="textarea" rows="2" autosize v-model="formtwo.constructionUnit" name="constructionUnit" label="施工单位" placeholder="施工单位" :label-width="60" maxlength="20" :rules="[{ required: true, message: '施工单位不能为空' }]"></van-field>
                        <van-field v-if="form.missionType==2" v-model="formtwo.constructionPersonnel" name="constructionPersonnel" type="number" label="施工人数" placeholder="施工人数" :label-width="60" maxlength="20" :rules="[{ required: true, message: '施工人数不能为空' }]"></van-field>
                        <van-field v-if="form.missionType==2" type="textarea" rows="2" autosize v-model="formtwo.constructionMemo" name="constructionMemo" label="施工内容" placeholder="施工内容" :label-width="60" maxlength="200" :rules="[{ required: true, message: '施工内容不能为空' }]"></van-field>
                        <van-field v-if="form.missionType==2" type="textarea" rows="2" autosize v-model="formtwo.dangerousMemo" name="dangerousMemo" label="隐患内容" placeholder="隐患内容" :label-width="60" maxlength="200" :rules="[{ required: true, message: '隐患内容不能为空' }]"></van-field>
                        <van-field :required="formtwo.requiredPhoto==1?true:false" label="现场照片" :label-width="60" name="picUrlList" :rules="[{ required: formtwo.requiredPhoto==1?true:false, message: '请上传现场照片' }]">
                            <template #input>
                                <van-uploader v-model="formtwo.picUrlList" multiple :max-count="5" :after-read="(file)=>afterRead(file, '')" :before-read="beforeRead" @delete="(file, detail) => deleteImg(file, detail,'')"/>
                            </template>
                        </van-field>
                    </van-cell-group>
                    <div class="btn_box">
                        <van-button round block type="primary" color="linear-gradient(55deg, #6261DB 0%, #3332B5 100%)" size="middle" @click="gettot()" v-if="formtwo.picUrlList.length==0 && formtwo.requiredPhoto==1">确认</van-button>
                        <van-button round block type="primary" color="linear-gradient(55deg, #6261DB 0%, #3332B5 100%)" size="middle" native-type="submit" :loading="loading" v-else>确认</van-button>
                    </div>
                </van-form>
            </div>
        </van-popup>
        <van-popup v-model="showpop" round closeable>
        <div class="show_box">
          <img v-if="xgwc" src="@/assets/finish.png"/>
          <img v-if="xgsb" src="@/assets/cuo.png"/>
          <div class="txt">{{txt}}</div>
          <div class="btnfoot">
              <van-button round block type="primary" color="#0283ef" size="middle"  @click="gourl(formtwo)" v-if="xgsb">任务详情</van-button>
              <van-button round block type="primary" color="#0283ef" size="middle" @click="goindex()" :class="{mt20:xgsb}">继续扫码</van-button>
              <van-button round block type="primary" color="#0283ef" size="middle" class="mt20" @click="showpop=false" v-if="!xgsb">关闭</van-button>
          </div>
        </div>
      </van-popup>
        <!-- :style="{ height: '50%' }" -->
    </div>
    
</template>

<script>
import wx from 'weixin-js-sdk'
import * as imageConversion from 'image-conversion';
import * as Minio from 'minio';
import axios from "axios";
export default {
  name: 'patroldetail',
  data () {
    return{
        typename:'',
        defaultValue:'',
        isname:true,
        form:{
            missionStartTime:'',
            missionEndTime:'',
        },
        formtwo:{
            name:'哈哈',
            newtime:'',
            patrolUser:'',
            patrolUserName:'',
            pointStatus:false,
            patrolMemo:'',
            constructionUnit:'',
            constructionPersonnel:'',
            constructionMemo:'',
            dangerousMemo:'',
            picUrlList:[],
            picUrlListtwo:[],
            requiredPhoto:'',
        },
        show:false,
        checked: true,
        minioClient: null,
        selectedFile: null,
        loading:false,
        sid:this.$route.params.sid,
        uid:this.$route.params.uid,
        uname:this.$route.params.uname,
        token:this.$route.params.token,
        type:this.$route.params.type,
        isuser:this.$route.params.isuser,
        isshow:false,
        isshow1:this.$route.params.isshow,
        showpop:false,
        txt:'巡更完成',
        xgwc:false,
        xgsb:false,
        bucketName:'',
        picUrlList:[],
        typename:'',
        periodicType:'',

    }
  },
  created(){
    this.periodicType=this.$route.params.periodicType
    let type=this.$route.params.periodicType
    this.typename=type==1?'巡更':type==2?'保洁':type==3?'工程':type==4?'巡检':''
    this.txt=type!=3?'任务':this.typename+'完成'
    document.title = this.typename+'详情'
    this.getlist()
  },
  mounted(){
    // this.minioClient = new Minio.Client({
    //     endPoint: 's3test.xunchen.work',
    //     port: 80,
    //     useSSL: false,
    //     accessKey: 'eOf5qgrVCzvqgbjfRxdf',
    //     secretKey: 'gvhBwUzgIonet3guhZ4N2fIPUCkuSBixPk5spmv3'
    // });
  },
  methods:{
    goindex(){
        let that=this;
        wx.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
            wx.miniProgram.redirectTo({url: '/pages/index/index?type=saomiao&periodicType='+that.$route.params.periodicType});
            }
        });
    },
    isInTimeRange(start,end) {
        let start1=start.replace(/-/g, '/')
        let end1=end.replace(/-/g, '/')
        const targetTime = new Date(start1);
        const targetTime1 = new Date(end1);
        const startTime = new Date(targetTime.getTime() - 5 * 60 * 1000); // 前5分钟
        const endTime = new Date(targetTime1.getTime() + 30 * 60 * 1000); // 后30分钟
        const currentTime = new Date();
        return currentTime >= startTime && currentTime <= endTime;
    },
    getshow(){
        let that=this;
        that.$axios.get(process.env.API_HOST+"sysmanager/applets/os-config/shop?shopSid="+that.form.shopSid+'&osType='+that.$route.params.periodicType,{
            headers:{
                userTicket:that.token
            }
        }).then((res) => {
            if(res.data.state==200){
              if(!res.data.data){
                that.$toast('请先在后台配置图片存储信息')
              }else{
                const date = new Date();
                const year = date.getFullYear();
                const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份是从0开始的，所以要加1，并且保证是两位数
                const day = ('0' + date.getDate()).slice(-2); // 保证是两位数
                // this.formtwo.newtime=`${year}-${month}-${day}`;
                this.formtwo={
                    sid:this.sid,
                    name:this.uname,
                    newtime:`${year}-${month}-${day}`,
                    patrolUser:this.uid,
                    patrolUserName:this.uname,
                    pointStatus:false,
                    patrolMemo:'',
                    constructionUnit:'',
                    constructionPersonnel:'',
                    constructionMemo:'',
                    dangerousMemo:'',
                    picUrlList:[],
                    picUrlListtwo:[],
                    outsiderSid:this.uid,
                    requiredPhoto:this.form.requiredPhoto,
                    itemList:this.form.itemList || []
                }
                // this.name=uni.getStorageSync('user').userName
                this.show=true
                that.bucketName=res.data.data.bucketName || ''
                that.minioClient = new Minio.Client({
                  endPoint: res.data.data.pathUrl,
                  //port: 80,
                  //useSSL: false,
                  port: 443,
                  useSSL: true,
                  accessKey: res.data.data.accessKey,
                  secretKey: res.data.data.secretKey
                });
              }
                // that.pointName=that.list.length>0?that.list[0].pointName:'任务点位详情'
            }
        })
        
    },
    gettot(){
      this.$toast('请上传图片');
    },
    goSubmit(values){
        let that=this
        that.xgwc=false
        that.xgsb=false
        that.loading=true
        let isvalue=true
        let form=JSON.parse(JSON.stringify(that.formtwo))
        if(form.itemList.length>0){
            form.itemList.filter((item, i) => {
                delete item.imgUrltwo
                if(item.itemValue==='' || item.itemValue==null){
                    isvalue=false
                    that.loading=false 
                }
            })
        }
        if(!isvalue){
            that.$toast('请选择点位确认项状态');
            return
        }
        form.picUrlList=that.formtwo.picUrlListtwo
        form.pointStatus=!that.formtwo.pointStatus?0:-1
        form.periodicType=that.$route.params.type
        that.$axios.put(process.env.API_HOST+"pms/app/patrol/daily/mission/point",form,{ 
            headers:{
                userTicket:that.token
            }
        }).then((res) => {
            that.loading=false
            if(res.data.state==200){
                that.txt=that.typename+'完成'
                that.showpop=true
                that.xgwc=true
                that.show=false
                that.getlist()
                console.log("提交成功")
            }else{
                that.txt=res.data.message || that.typename+'失败'
                that.showpop=true
                that.xgsb=true
            }
        }).catch((error) =>{
            that.loading=false
        });
    },
    dateNumber(sp=''){
        const date = new Date()
        const  year = date.getFullYear()
        const  month = date.getMonth()>9?date.getMonth()+1:'0'+(date.getMonth()+1)
        const  day = date.getDate();
        return year.toString()+month+day.toString()
    },
    getUUID () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
        })
    },
    beforeRead(file){
      if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
        this.$toast('图片格式不正确');
        return false;
      }
      return new Promise((resolve) => {
          imageConversion.compressAccurately(file, 400).then(res => {
              let res2= new File([res], file.name, {
                type: res.type,
                lastModified: Date.now()
              });
              this.selectedFile=res2
              resolve(res);
          });
      })
    }, 
    afterRead(files, mindex) {
        let that=this;
        files.status = "uploading";
        files.message = "上传中...";
        const suffixType =that.selectedFile&&that.selectedFile.name?that.selectedFile.name.substr(that.selectedFile.name.lastIndexOf('.')):''
        const UrlName = `${that.dateNumber()}/${that.getUUID()}${suffixType}`
        if (!that.selectedFile) return;
        that.minioClient.presignedPutObject(that.bucketName, UrlName, 24 * 60 * 60, function (err, presignedUrl) {
        axios.put(presignedUrl, that.selectedFile, {
            headers: {'Content-Type': that.selectedFile.type},
            timeout: 1000 * 60 * 30,
            onUploadProgress: function (progressEvent) {
                that.getFipstwo(UrlName)
                /** 返回文件当前上传的进度* */
                console.log({loaded:progressEvent.loaded,total:progressEvent.total,proNum:Number((progressEvent.loaded / progressEvent.total * 100).toFixed(0))})
                
            }
        }).then((res) => {
            that.$toast('上传成功')
            files.status = "";
            if(mindex===''){
                that.formtwo.picUrlListtwo.push({imgUrl:UrlName})
                return
            }
            that.formtwo.itemList[mindex].imgUrl=UrlName
        }).catch((error) => {
            if(mindex===''){
                that.formtwo.picUrlList.splice(that.formtwo.picUrlList.length-1,1)
                that.$toast('上传失败')
                files.status = "";
                return
            }
            that.formtwo.itemList[mindex].imgUrl=''
            that.formtwo.itemList[mindex].imgUrltwo=[]
            that.$toast('上传失败')
            files.status = "";
        })
        })
        return
        files.forEach(element => {
            element.rate = 10; // 通过给file对象的rate属性赋值，来自主设置进度值
            setTimeout(() => {
            element.status = null;
            }, 2000);
        });
    },
    deleteImg(file, detail,mindex) {
        if(mindex>=0){
            this.formtwo.itemList[mindex].imgUrl=''
            this.formtwo.itemList[mindex].imgUrltwo=[]
            return
        }
        this.formtwo.picUrlListtwo.splice(detail.index, 1)
    },
    async getFipstwo(UrlName){
        this.minioClient.presignedUrl('GET',this.bucketName, UrlName, function (err, presignedUrl) {
            console.log("图片地址地址",presignedUrl)
        })           
    },
    getlist(){
        let that = this
        that.$axios.get(process.env.API_HOST+"pms/app/patrol/daily/mission/detail?sid="+that.sid,{
            headers:{
                userTicket:that.token
            }
        }).then((res) => {
            if(res.data.state==200){
                let name=''
                if(res.data.data.itemList && res.data.data.itemList.length>0){
                    res.data.data.itemList.filter((item, i) => {
                        item.itemValueName=item.itemValue==1?'正常':item.itemValue==0?'异常':''
                        item.imgUrl=item.imgUrl && item.imgUrl!=null?item.imgUrl:''
                        item.imgUrltwo=item.imgUrl && item.imgUrl!=null?[{url:item.imgUrl}]:[]
                    })
                }
                that.form=res.data.data
                that.form.missionTypeName=that.form.missionType==1?'日常'+(that.periodicType==3?'工程检查':that.typename):that.form.missionType==2?'商户装修'+(that.periodicType==3?'工程检查':that.typename):that.form.missionType==3?'商户闭店检查':''
                that.form.expect=that.gettimetwo(that.form.missionStartTime)+'-'+that.gettimetwo(that.form.missionEndTime)
                that.form.patrolTime=that.gettimetwo(that.form.patrolTime || '')
                if(that.form.patrolUserName!='' && that.form.outsidersList.length>0){
                    that.form.outsidersList.filter((item, i) => {
                        name+=(i>0?'、':'')+item.systemOutsidersName+' '
                    })
                    let index= that.form.outsidersList.findIndex(item => item.systemOutsidersName === that.form.patrolUserName)
                    that.isname=index>=0?true:false
                }
                that.form.systemOutsidersName=name
                that.isshow=that.isInTimeRange(that.form.missionStartTime,that.form.missionEndTime)
                if(res.data.data.imageList.length>0  || that.form.itemList.length>0){
                    that.$axios.get(process.env.API_HOST+"sysmanager/applets/os-config/shop?shopSid="+that.form.shopSid+'&osType='+that.$route.params.periodicType,{
                        headers:{
                            userTicket:that.token
                        }
                    }).then((res1) => {
                        if(res1.data.state==200){
                            that.bucketName=res1.data.data.bucketName || ''
                            that.minioClient = new Minio.Client({
                                endPoint: res1.data.data.pathUrl,
                                //port: 80,
                                //useSSL: false,
                                // endPoint: res1.data.data.pathUrl,
                                port: 443,
                                useSSL: true,
                                accessKey: res1.data.data.accessKey,
                                secretKey: res1.data.data.secretKey
                            });
                            if(that.form.itemList && that.form.itemList.length>0){
                                that.form.itemList.map((item) => {
                                    console.log(item)
                                    if(item.imgUrl && item.imgUrl!='' && item.imgUrl!=null){
                                        that.minioClient.presignedUrl('GET', that.bucketName, item.imgUrl, function (err, presignedUrl) {
                                            item.imgUrltwo=[{url:presignedUrl}]
                                        })   
                                    }
                                    
                                })
                            }
                            res.data.data.imageList.map((item) => {
                                that.minioClient.presignedUrl('GET', that.bucketName, item.imgUrl, function (err, presignedUrl) {
                                    that.picUrlList.push({url:presignedUrl})
                                })   
                            })
                        }   
                    })
                }
            }else {
                that.$toast(res,data.message)
            }
        })			
    },
    getstateName(val){
        let name=val==0?('待'+(this.$route.params.periodicType!=3?this.typename:'检查')):val==1?'未开始':val==2?('未'+(this.$route.params.periodicType!=3?this.typename:'完成')):val==3?((this.$route.params.periodicType!=3?this.typename:'任务')+'异常'):val==4?'已完成':val==-1?'已作废':''
        return name
    },
    gettimetwo(val){
        let time=val!=''?val.split(' ')[1]:''
        let times=''
        if(time && time!=''){
            times=time.split(':')
        }
        return times!=''?times[0]+':'+times[1]:''
    },
  }
}
</script>

<style scoped>
.max60{
  max-height: 60vh;
  overflow-y: auto;
}
.show_box{
  width: 80vw;
  background: #fff;
  box-sizing: border-box;
  padding:1rem 0.5rem ;
}
.show_box img{
    width: 2rem;
    height: 2rem;
    margin: 0 auto 0.2rem;
    display: block;
}
.show_box .txt{
  font-size: 0.6rem;
  color: #333;
  text-align: center;
  font-weight: bold;
}
.btnfoot{
  width: 80%;
  margin: 0.7rem auto 0;
}
.mt20{
  margin-top: 0.5rem;
}
.footbtn{
    width: 100%;
    position: fixed;
    bottom: 0;
    background: #fff;
    padding: 0.5rem 16px 0.7rem;
    box-sizing: border-box;
    /* margin: 0.5rem 0 0.7rem; */
}
.btn_box{
    box-sizing: border-box;
    padding: 10px 16px;
}
.row-end{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.pop_box{
    box-sizing: border-box;
	/* padding: 0 0.25rem 0.45rem; */
}
.pop_box .title{
    font-size: 0.45rem;
    font-weight: bold;
    text-align: center;
    padding: 16px 0;
}

.flist{
    /* width: 100; */
    margin: 0.2rem auto 0;
    border-radius: 0.2rem;
    box-sizing: border-box;
    padding: 0.2rem 0.4rem 0;
}
.d_box{
    width: 100%;
    margin-top: 0.2rem;
    border-radius: 0.2rem;
    box-sizing: border-box;
    background: #E8EBEF;
    overflow: hidden;
}
.d_box .title{
    position: relative;
    font-size: 0.42rem;
    font-weight: bold;
    border-bottom: 0.02rem solid rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    padding: 0.3rem 0.5rem;
}
.d_box .title::after{
    position: absolute;
    content: "";
    width: 0.12rem;
    height: 0.5rem;
    background: #6236FF;
    left: 0.2rem;
    top: 50%;
    margin-top: -0.25rem;
    border-radius: 0.18rem;
}
.d_box >>> .van-cell-group,.d_box >>> .van-cell{
  background: #E8EBEF;
}
.d_box >>> .van-field__label,.d_box >>> .van-field__control{
    color: #303133;
}
.pop_box >>> .van-cell-group--inset{
    margin: 0;
}
.scolor4{
    color: #04b46a;
}
.scolor2{
    color: #ff0000;
}
.scolor3{
    color: #9254de;
}
.scolor0{
    color: #1890ff;
}
.scolor1{
    color: #fa8c16;
}
.scolor0{
    color: #1a91ff;
}
.scolor5{
    color: #cccccc;
}
.red >>>.van-field__control{
    color: red !important;
}
>>> .van-radio{
    margin-left: 8px;
}
</style>


// WEBPACK FOOTER //
// src/view/patroldetail.vue